import clsx from "clsx";
import React from "react";

type Props = { className?: string; wrapperClassName?: string };

export default function VerticalRule(props: Props) {
  return (
    <div className={clsx(["flex items-center h-full", props.wrapperClassName])}>
      <div className={clsx(["w-px h-vr bg-gray-400", props.className])}></div>
    </div>
  );
}
